var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tabs',{attrs:{"default-active-key":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"申通"}},[_c('sto-create-form')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"圆通"}},[_c('yto-create-form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }